import styled from "styled-components";
import { Button } from "antd";

// 漂浮圓形按鈕的共用基底（右下「新增」與右上「快轉」共用），定位由使用端指定。
// && 提高權重：antd v5 的 CSS-in-JS 樣式在元件掛載時才注入，單一 class 的覆寫會被蓋掉。
const FloatingButton = styled(Button)`
  && {
    position: fixed;
    z-index: 100;
    display: flex;
    justify-content: center;
    align-items: center;
    width: 45px;
    height: 45px;
    padding: 0;
    border-radius: 50%;
    box-shadow: 0 1.9px 2.9px -3px rgba(0, 0, 0, 0.071), 0 4.5px 7.3px -3px rgba(0, 0, 0, 0.102),
      0 9px 14.9px -7px rgba(0, 0, 0, 0.128), 0 17.8px 30.7px -6px rgba(0, 0, 0, 0.159),
      0 47px 85px -13px rgba(0, 0, 0, 0.23);
  }
`;

export default FloatingButton;
